import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// Import library module
import { HttpClientModule } from '@angular/common/http';
import { MatGridListModule } from '@angular/material/grid-list';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AihobsEcsModule } from './aihobs-ecs/aihobs-ecs.module';
import { HicreaSsoModule as AissSsoModule } from './aiss-sso/aiss-sso.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CollaboPortalModule } from './collabo-portal/collabo-portal.module';
import { DoctorsStationModule } from './doctors-station/doctors-station.module';
import { DrDishModule } from './dr-dish/dr-dish.module';
import { Auth0SdkLoginComponent } from './features/auth0-sdk/components/auth0-sdk-login/auth0-sdk-login.component';
import { HayfeverModule } from './hayfever/hayfever.module';
import { HealthpicksOperatorModule } from './healthpicks-operator/healthpicks-operator.module';
import { HealthpicksModule } from './healthpicks/healthpicks.module';
import { HicreaSsoModule } from './hicrea-sso/hicrea-sso.module';
import { PasswordResetFinishedComponent } from './landing/password-reset-finished/password-reset-finished.component';
import { LasuiteModule } from './lasuite/lasuite.module';
import { AccountIntegrationComponent } from './pages/account-integration/account-integration.component';
import { Auth0ErrorComponent } from './pages/auth0-error/auth0-error.component';
import { Auth0SdkTestComponent } from './pages/auth0-sdk-test/auth0-sdk-test.component';
import { AuthorizeComponent } from './pages/authorize/authorize.component';
import { DoctorsNextModule } from './pages/doctors-next/doctors-next.module';
import { LoginConfirmComponent } from './pages/login-confirm/login-confirm.component';
import { LoginGuideComponent } from './pages/login-guide/login-guide.component';
import { RedirectComponent } from './pages/redirect/redirect.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { TestComponent } from './pages/test/test.component';
import { UnblockComponent } from './pages/unblock/unblock.component';
import { UpdatedPasswordComponent } from './pages/updated-password/updated-password.component';
import { VerifyComponent } from './pages/verify/verify.component';
import { SasClinicModule } from './sas-clinic/sas-clinic.module';
import { SasManagementModule } from './sas-management/sas-management.module';
import { SasStationModule } from './sas-station/sas-station.module';
import { SgzpApp2Module } from './sgzp-app2/sgzp-app2.module';
import { SgzpApp4Module } from './sgzp-app4/sgzp-app4.module';
import { SgzpApp5Module } from './sgzp-app5/sgzp-app5.module';
import { SgzpApp6Module } from './sgzp-app6/sgzp-app6.module';
import { SgzpMasterModule } from './sgzp-master/sgzp-master.module';
import { BaseResetPasswordComponent } from './shared/components/base-reset-password/base-reset-password.component';
import { FaviconSwitchComponent } from './shared/components/base-reset-password/favicon-switch.component';
import { AccessDeniedComponent } from './shared/pages/errors/access-denied/access-denied.component';
import { VerifyEmailComponent } from './shared/pages/errors/verify-email/verify-email.component';
import { LandingComponent } from './shared/pages/landing/landing.component';
import { Auth0Component } from './shared/services/auth0/auth0.component';
import { SharedModule } from './shared/shared.module';
import { SokusaiManagementModule } from './sokusai-management/sokusai-management.module';
import { SokusaiModule } from './sokusai/sokusai.module';
import { SuguyakuModule } from './suguyaku/suguyaku.module';
import { TradersModule } from './traders/traders.module';
import { WellbeanModule } from './wellbean/wellbean.module';
import { WelltectModule } from './welltect/welltect.module';

@NgModule({
  declarations: [
    AppComponent,
    Auth0SdkTestComponent,
    Auth0SdkLoginComponent,
    LandingComponent,
    AccessDeniedComponent,
    VerifyEmailComponent,
    Auth0Component,
    TestComponent,
    VerifyComponent,
    AuthorizeComponent,
    LoginConfirmComponent,
    RedirectComponent,
    UnblockComponent,
    ResetPasswordComponent,
    BaseResetPasswordComponent,
    FaviconSwitchComponent,
    AccountIntegrationComponent,
    LoginGuideComponent,
    PasswordResetFinishedComponent,
    UpdatedPasswordComponent,
    Auth0ErrorComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    BrowserAnimationsModule,
    NgxSpinnerModule,
    DoctorsStationModule,
    DoctorsNextModule,
    CollaboPortalModule,
    SgzpApp2Module,
    SgzpApp4Module,
    SgzpApp5Module,
    SgzpApp6Module,
    HicreaSsoModule,
    AissSsoModule,
    AihobsEcsModule,
    SgzpMasterModule,
    HttpClientModule,
    SharedModule,
    DrDishModule,
    SasStationModule,
    SuguyakuModule,
    WelltectModule,
    HayfeverModule,
    SasClinicModule,
    TradersModule,
    WellbeanModule,
    MatGridListModule,
    LasuiteModule,
    SokusaiModule,
    SokusaiManagementModule,
    SasManagementModule,
    HealthpicksOperatorModule,
    HealthpicksModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
